interface PromiseConstructor {
    noop<T = void>(): Promise<T>;

    wait(ms: number): Promise<void>;

    wait<T>(ms: number, val: T): Promise<T>;
}

interface AlwaysHandler<T> {
    (res: T): void;

    (res: undefined, error: any): void;
}

interface Promise<T> {
    always(fn: AlwaysHandler<T>): void;

    /**
     * shutdown promise
     * @param [logError=true] - logging if error
     */
    shutdown(logError?: boolean): void;
}

Promise.noop = function () {
    return new Promise<any>(() => {});
};

Promise.wait = function (...args: any[]) {
    const ms = args[0];
    const val = args[1];
    const useValue = args.length > 1;
    if (useValue) {
        return new Promise<any>(resolve => {
            _.delay(() => resolve(val), ms);
        });
    }
    return new Promise<void>(resolve => {
        _.delay(() => resolve(), ms);
    });
};

Promise.prototype.always = function (this: Promise<any>, fn: AlwaysHandler<any>) {
    this.then(fn, _.partial(fn, undefined));
};

Promise.prototype.shutdown = function (this: Promise<any>, logError = altosoft.isDebug) {
    if (logError) {
        this.always((...args: unknown[]) => args[1] && console.error(args[1]));
    } else {
        this.always(_.noop);
    }
};
